if (!customElements.get("image-quote-grid")) {
  customElements.define(
    "image-quote-grid",
    class ImageQuoteGrid extends HTMLElement {
      constructor() {
        super();
        this.quoteTrackEl = null;
        this.progressEl = null;
        this.quoteSlideEls = [];
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.scheduleProgressUpdate = this.scheduleProgressUpdate.bind(this);
        this.rafId = null;
      }

      connectedCallback() {
        this.quoteTrackEl = this.querySelector("[data-image-quote-track]");
        this.progressEl = this.querySelector("[data-image-quote-progress]");

        if (!this.quoteTrackEl || !this.progressEl) {
          return;
        }

        this.quoteSlideEls = Array.from(
          this.querySelectorAll("[data-image-quote-slide]"),
        );

        if (this.quoteSlideEls.length < 2) {
          return;
        }

        this.updateProgress();
        this.quoteTrackEl.addEventListener("scroll", this.handleScroll, {
          passive: true,
        });
        window.addEventListener("resize", this.handleResize);
      }

      disconnectedCallback() {
        if (this.quoteTrackEl) {
          this.quoteTrackEl.removeEventListener("scroll", this.handleScroll);
        }

        window.removeEventListener("resize", this.handleResize);

        if (this.rafId !== null) {
          window.cancelAnimationFrame(this.rafId);
          this.rafId = null;
        }
      }

      handleScroll() {
        this.scheduleProgressUpdate();
      }

      handleResize() {
        this.scheduleProgressUpdate();
      }

      scheduleProgressUpdate() {
        if (this.rafId !== null) {
          return;
        }

        this.rafId = window.requestAnimationFrame(() => {
          this.updateProgress();
          this.rafId = null;
        });
      }

      updateProgress() {
        const activeIndex = this.getActiveIndex();
        const progressWidth = 100 / this.quoteSlideEls.length;

        this.progressEl.style.setProperty(
          "--image-quote-grid-progress-width",
          `${progressWidth}%`,
        );
        this.progressEl.style.setProperty(
          "--image-quote-grid-progress-offset",
          `${activeIndex * 100}%`,
        );
      }

      getActiveIndex() {
        const trackLeft = this.quoteTrackEl.getBoundingClientRect().left;
        let activeIndex = 0;
        let activeDistance = Number.POSITIVE_INFINITY;

        this.quoteSlideEls.forEach((slideEl, index) => {
          const distance = Math.abs(
            slideEl.getBoundingClientRect().left - trackLeft,
          );

          if (distance < activeDistance) {
            activeIndex = index;
            activeDistance = distance;
          }
        });

        return activeIndex;
      }
    },
  );
}
